import { createStore } from 'redux';
import rootReducer from './reducers';

const configureStore = () => {
    if (process.env.NODE_ENV === 'development' || 'test') {
        /* eslint-disable no-underscore-dangle */
        return createStore(
            rootReducer,/* preloadedState, */
            //@ts-ignore
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        )
        /* eslint-enable */
    }
    return createStore(
        rootReducer
    )
}

const store = configureStore();

export type RootState = ReturnType<typeof store.getState>

export default store;
